// MODULES
import React from "react";
import PropTypes from "prop-types";

// CLASSES
import Session from "@classes/Session";

// COMPONENTS
import DefaultFields from "../../components/DefaultFields/DefaultFields";
import FieldsCollection from "@components/FieldsCollection/FieldsCollection";

// HELPERS
import {createClassName} from "@helpers/utils";
import fulfillmentCheck from "./GDPR.fulfillment";
import CheckboxWithName from "../../components/CheckboxWithName/CheckboxWithName";


export default class CobCustomerInformation extends React.PureComponent {
	static propTypes = {
		id: PropTypes.string.isRequired,
		title: PropTypes.string.isRequired,
		session: PropTypes.instanceOf(Session).isRequired,
		sectionNumber: PropTypes.number.isRequired,
		number: PropTypes.number.isRequired,
		prevState: PropTypes.object,
		onChange: PropTypes.func.isRequired,
	};

	static companyExclusive = false;
	static privateExclusive = false;
	static fields = _getFields();

	state = _getInitialState.call(this);

	componentDidUpdate(prevProps, prevState) {
		const {props, state} = this;
		const {id, onChange} = props;

		if (prevState.fields !== state.fields) {
			onChange(id, {...state}, fulfillmentCheck(props, state));
		}
	}

	render() {
		const {props, state} = this;
		const {title} = props;

		const classes = createClassName("Cob-CustomerInformation", {
			"Cob-View": true,
			"fulfilled": state.isFulfilled,
		});

		return (
			<div className={classes}>
				<DefaultFields fields={this.constructor.fields}/>

				<div style={{alignItems: "flex-start", width: "100%"}}>
					<h2>{title}</h2>

					<div className="description">
						<p style={{marginTop: "0"}}>
							Undertecknad medger härmed att Bolaget behandlar personuppgifter som lämnas i samband med
							ingåendet av detta avtal. Personuppgifterna används av Bolaget för öppnande av depå och i
							övrigt
							vid händelser förenade med vad som framgår av detta avtal.
						</p>
					</div>

					<FieldsCollection
						fields={[
							{
								render: (
									<CheckboxWithName
										label="Jag ger mitt medgivande till personuppgiftshantering"
										name="radio_customer_personal_info"
										value={state.fields.radio_customer_personal_info.checked ? "yes" : "no"}
										checked={state.fields.radio_customer_personal_info.checked}
										onChange={this._onCheckboxChange}
									/>
								),
							},
						]}
					/>
				</div>
			</div>
		);
	}

	_onCheckboxChange = (name, checked) => {
		this.setState({
			fields: {
				...this.state.fields,
				[name]: {...this.state.fields[name], checked}
			}
		});
	};
}


// PRIVATE FUNCTIONS
function _getFields() {
	return [
		"radio_customer_personal_info"
	];
}

function _getInitialState() {
	if (this.props.prevState) return {...this.props.prevState};
	return {
		validFields: [],
		fields: {
			"radio_customer_personal_info": {
				checked: false
			}
		},
	};
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/GDPR/GDPR.js